import apiService from './apiService';

export default class AuditChecklistHistoryItemApiService {

    async addAuditChecklistHistoryItems (newAuditChecklistItems) {
        const addAuditChecklistResponse = await apiService.postData('api/AuditChecklistHistoryItem', newAuditChecklistItems);
        return addAuditChecklistResponse.data;
    }
}
